import { gql } from '@common/hooks';
import type { TypedDocumentNode } from '@common/hooks';
import type {
  TiersQueryCgResponse,
  TiersQueryVariables,
} from '@common/graphql/schema';

export const TiersQuery: TypedDocumentNode<
  TiersQueryCgResponse,
  TiersQueryVariables
> = gql`
  query Tiers {
    tiers {
      id
      name
      visibilityOffset
      fee
      suppliers {
        id
        name
        statusForCurrentOrganization {
          id
          status
        }
      }
    }
  }
`;

export type Tier = TiersQueryCgResponse['tiers'][0];

export type Supplier = Tier['suppliers'][0];

export type TiersFlatType = Omit<Tier, 'suppliers'>;

type TiersFlatQueryResponse = {
  tiers: TiersFlatType[];
};

export const TiersFlatQuery: TypedDocumentNode<TiersFlatQueryResponse> = gql`
  query SupplierAvailableTiers {
    tiers {
      id
      fee
      name
      visibilityOffset
    }
  }
`;
